<template>
    <div>
        <sek-section />

        <sek-about-section />

        <sek-description-section />

        <sek-blog />

        <sek-pop-up />
    </div>
</template>

<script>
import SekSection from "@/views/home/sections/SekSection"
import SekAboutSection from "@/views/home/sections/SekAboutSection"
import SekDescription from "@/views/home/sections/SekDescription"
import SekBlog from './sections/SekBlog.vue'
import SekPopUp from '../../components/utils/SekPopUp.vue'

export default {
    components: {
        "sek-section": SekSection,
        "sek-about-section": SekAboutSection,
        "sek-description-section": SekDescription,
        "sek-blog": SekBlog,
        SekPopUp,
    }
}
</script>

<style lang="scss">
</style>